import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'react-tooltip'
import ALARM_STATES, { colorAlarm, IO_STATUS } from './alarmSettings'

const hourCell = hour => ({
	name: <CustomCell value={{ temp: hour }} />,
	minWidth: '42px',
	cell: row => (
		<CustomCell
			value={row.values['hour_' + hour]}
			tabNums
			tooltipId={`io-status-${row.device.id}-${row.day}-${hour}`}
		/>
	),
	center: 'true',
	grow: 1,
	compact: 'true',
})

const ioStatusConfig = {
	[IO_STATUS.ALARM]: {
		className: 'bg-red-500',
		tooltip: 'Alarm aktiv',
	},
	[IO_STATUS.FUNCTIONAL]: {
		className: 'bg-green-500',
		tooltip: 'Kein Alarm',
	},
	[IO_STATUS.OFFLINE]: {
		className: 'bg-gray-600',
		tooltip: 'Offline / keine Schaltung möglich',
	},
}

const CustomCell = ({ value, tabNums, tooltipId }) => {
	const [alarmProps, setAlarmProps] = useState({ color: '', icon: null })

	const alarm = value?.alarm || null
	let temp = value?.temp
	const ioStatus = value?.ioStatus || null

	useEffect(() => {
		setAlarmProps(colorAlarm(alarm))
	}, [alarm])

	if (ioStatus) {
		const statusConfig =
			ioStatusConfig[ioStatus] || ioStatusConfig[IO_STATUS.OFFLINE]

		return (
			<div className="flex items-center justify-center w-full h-full px-0">
				<div
					data-tooltip-id={tooltipId}
					className={`${statusConfig.className} h-3 w-full border-x border-white`}
				/>
				{tooltipId && <Tooltip id={tooltipId} content={statusConfig.tooltip} />}
			</div>
		)
	}

	return (
		<div
			className={
				alarmProps.color +
				(tabNums ? 'tabular-nums ' : '') +
				'grid justify-end items-center w-full pr-1'
			}
		>
			{alarm && alarm !== ALARM_STATES.NO_ALARM && (
				<div className="flex items-end justify-center w-full h-4">
					{alarmProps?.icon && <FontAwesomeIcon icon={alarmProps?.icon} size="lg" />}
				</div>
			)}
			<div>{temp}</div>
		</div>
	)
}

CustomCell.propTypes = {
	value: PropTypes.object,
	tabNums: PropTypes.bool,
	tooltipId: PropTypes.string,
}

export default hourCell
